module.exports = __webpack_public_path__ + "img/horizontal_6_4_8019.90ea98ed.png";